
































import { Vue, Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { ExternalValidationResults } from "../../../../domain/document";
import { IHisInformationAccessible } from "../../../../domain/his";
import { ContentPane } from "../panes";
import { IToolTabDefinition } from "../contents";
import { ITabDefinition } from "../contents/tools";
import CommonComponentsContainer from "../CommonComponentsContainer.vue";
import { ICommonComponentsContainable } from "../ICommonComponentsContainable";
import { DocumentEditorMixin } from "../mixins";
import { EditingDocument } from "../EditingDocument";
import { Header, Footer } from "./contents";

@Component({
  components: {
    HeaderPane: Header,
    ContentPane,
    FooterPane: Footer,
    CommonComponentsContainer,
  },
})
export default class DocumentEditor extends Mixins(DocumentEditorMixin) implements ICommonComponentsContainable {
  getCommonComponentsContainer(): Vue {
    return this.$refs.commonComponents as Vue;
  }

  @Prop({ default: false })
  isEmbedded: boolean;

  @Prop()
  defaultToolTabName: string;

  @Prop()
  additionalToolTabs: IToolTabDefinition[];

  @Prop()
  additionalDocumentViewToolTabs: ITabDefinition[];

  @Prop({ default: false })
  hasAdditionalComments: boolean;

  @Prop({ default: false })
  shouldValidateExistingLinkedDocument: boolean;

  @Prop()
  validateWithExternalValidationUrl: () => Promise<ExternalValidationResults>;

  @Prop()
  hisInformationAccessor: IHisInformationAccessible;

  mounted() {
    this.$registerCloseHandler(this.deleteCreateToken);
  }

  onDocumentRegistered(id: number, destinationRoute?: any, isTemporary?: boolean, archiveId?: number) {
    this.clearCreateTokenTimer();
    this.clearWriteTokenTimer();
    this.documentRegistered(id, destinationRoute, isTemporary, archiveId);
  }

  async deleteCreateToken(): Promise<void> {
    this.clearCreateTokenTimer();
    await this.deleteDocumentCreateToken();
  }

  /**
   * DocumentEditorMixinに移動してdestroyed()からも呼ぶようにしたほうが安全なように見える
   */
  clearCreateTokenTimer(): void {
    if (!this.createTokenTimer) { return; }
    clearInterval(this.createTokenTimer);
    this.createTokenTimer = null;
  }

  @Watch("document")
  onDocumentUpdated(newValue: EditingDocument, oldValue: EditingDocument) {
    if (!oldValue && newValue) {
      if (newValue.source && newValue.source.unmanagedInformation && this.redirectUneditableDocument) {
        this.redirectUneditableDocument(newValue.source);
      }
    }
  }
}
